import '../social_content_following_comments_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.InstagramContentFollowingCommentsView extends Monitoring.Views.SocialContentFollowingCommentsView

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @searchQuery.addContextKind('ig_following_comments')
    @searchQuery.addChildCommentsFor(@rootParentId)
    @addContextLimit()
    dateFrom = Date.create(@socialContent.created_at()).getTime() + 1
    @searchQuery.addDateFrom(dateFrom)
    @searchQuery.setNowDate(true)
    @searchQuery.addExcludedContentId(@socialContent.externalId())
